import React from 'react';

import { RichText } from 'src/components/RichText/RichText';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { BlockType } from './blockConfigAggregator';

type PageBuilderBlockProps = BlockType;

/**
 * Return the PB Block
 * @param props
 * @constructor
 */
export function PageBuilderBlock(props: PageBuilderBlockProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderBlockProps>(props);

    const blockClassNames = ['pageBuilderBlockGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        blockClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={blockClassNames}
        >
            {props.richContent && <RichText content={props.richContent} />}
        </PageBuilderElementWrapper>
    );
}
